/**
 * Transform booking parts into a a group of refundables for ancillaries.
 * Only 1 item inside right now (insurance)
 */
export function transformRefundableGroupsAncillary(bookingParts: ApiBookingPart[], response: ApiSchema['BookingResponse']) {
    const apiBooking = response?.booking;
    if (!apiBooking) {
        return [];
    }

    return bookingParts
        .filter(bp => bp.objectType === 'Ancillary')
        .reduce<RefundableGroupAncillary[]>((list, bookingPart) => {
            assignAncillary(list, bookingPart, apiBooking);
            return list;
        }, []);
}

/**
 *
 */
function assignAncillary(
    list: RefundableGroupAncillary[],
    activity: ApiSchema['Ancillary'],
    apiBooking: ApiSchema['Booking'],
) {
    const type = 'Ancillary';
    const id = '';
    const refundable = transformRefundableAncillary(activity, apiBooking);

    let refundableGroup = list
        .filter(p => p.type === type)
        .find(p => p.id === id);
    if (!refundableGroup) {
        refundableGroup = {
            id,
            type,
            refundables: [],
        } satisfies RefundableGroupAncillary;
        list.push(refundableGroup);
    }

    refundableGroup.refundables.push(refundable);
}
